import {connect} from 'react-redux';
import ButtonsSubmitCancel from './ButtonsSubmitCancel';

export default connect(
  null,
  null
)(ButtonsSubmitCancel);
